import React from 'react';
import SubTopicoTexto from './SubTopicoTexto';
import CheckBox from '@mui/material/Checkbox';
import '../Estilos/CampoEdicoes.css';
export default function CampoEdicoes(props) {
  return (
    <div
      style={{
        className: 'ContainerCampoEdicoes',
        width: props.width,
        backgroundColor: 'white',
        height: props.height,
        marginLeft: props.left,
        marginRight: props.right,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        minHeight: props.minHeight,
        minWidth: props.minWidth,
        maxHeight: props.maxHeight,
        padding: props.padding ? props.padding : '20px',
        overflowY: props.overflowY ? props.overflowY : 'none',
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <SubTopicoTexto titulo={props.titulo} />

        {props.children}
      </div>
    </div>
  );
}

function SubTituloCampoEdicoes(props) {
  return (
    <h1
      style={{
        width: '90%',
        textAlign: 'left',
        color: '#005288',
        fontFamily: 'montserrat',
        fontSize: '14px',
        margin: 0,
        marginTop: props.top !== undefined ? props.top : 16,
      }}
    >
      {props.nome}
    </h1>
  );
}

function InputCampoEdicoes(props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '90%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        alignContent: 'center',
        marginTop: props.top !== undefined ? props.top : 0,
      }}
    >
      <CheckBox
        size="small"
        color="success"
        checked={props.isChecked ? true : false}
        onClick={() => {
          props.clicado(props.isChecked ? false : true);
        }}
        disabled={props.disabled}
      />

      <h1
        style={{
          textAlign: 'left',
          verticalAlign: 'center',
          color: '#2f2f2f',
          fontFamily: 'montserrat',
          fontSize: '12px',
          fontWeight: 600,
        }}
      >
        {props.desc}
      </h1>
    </div>
  );
}

export { SubTituloCampoEdicoes, InputCampoEdicoes };
